import {
  useSMSManualScheduledWSSubscription,
  useSMSDataV3WSSubscription,
  useSMSPreferenceEventSubscription,
  useSMSTagNotificationSubscription,
  useReviewEventSubscription,
  useFaxEventSubscription,
  useFaxCountEventSubscription,
  useFaxReadEventSubscription,
  useFaxTagEventSubscription,
  useNewBlockedFaxEventSubscription,
  useSMSWSSubscription,
  useSMSTaskWSSubscription,
  useInboxThreadItemWSSubscription,
  useInboxThreadItemTagWSSubscription,
  useThreadAiStateWSSubscription,
} from './hooks';

export const useAllMessagingWebsockets = () => {
  useSMSManualScheduledWSSubscription();
  useSMSDataV3WSSubscription();
  useInboxThreadItemWSSubscription();
  useSMSWSSubscription();
  useSMSPreferenceEventSubscription();
  useSMSTagNotificationSubscription();
  useSMSTaskWSSubscription();
  useReviewEventSubscription();
  useFaxEventSubscription();
  useFaxTagEventSubscription();
  useFaxCountEventSubscription();
  useFaxReadEventSubscription();
  useNewBlockedFaxEventSubscription();
  useInboxThreadItemTagWSSubscription();
  useThreadAiStateWSSubscription();
};
